import { Injectable } from '@angular/core';
import { API_URL } from 'common/constants/sm-constants';
import { StudentInternshipModel } from 'common/models/page-models/student-side/internship/student-internship-data.model';
import {
  StudentInternshipGridPostParams,
  StudentInternshipListingModel,
} from 'common/models/page-models/student-side/internship/student-internship-grid-model';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';

@Injectable({
  providedIn: 'root',
})
export class StudentInternshipDataService extends GridDataService<
  StudentInternshipListingModel,
  StudentInternshipModel
> {
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.StudentInternshipList, http, ss);
  }

  override getGridParams(param: any): GridPostParams {
    
    const params = new StudentInternshipGridPostParams();
  
    if (param && param.tabNumber) {
      params.tabNumber = param.tabNumber;
    } else {
      params.tabNumber = 1;  
    }
  
  
    return params;
  }
  

  createInstance(): StudentInternshipListingModel {
    return new StudentInternshipListingModel();
  }

  override getDeleteUrl(): string {
    return '';
  }
  override getDataParam(): string {
    return 'details';
  }

  // override modifyGridPostParams(queryParams: any): GridPostParams {
  //   console.log(queryParams,'queryParams')
  //   // queryParams = queryParams;
  //   queryParams['tabNumber']=1
  //   return queryParams;
  // }
}
